export default "__VITE_PUBLIC_ASSET__35dfa2e8__"